<template>
  <main>
<!--    <div class="app-title">-->
<!--      <div>-->
<!--        <h1>-->
<!--          <font-awesome-icon icon="sms"/>-->
<!--          {{ $t('smsHistory') }}-->
<!--        </h1>-->
<!--      </div>-->
<!--    </div>-->
    <div class="row">
      <div class="col-12">
        <div class="tile">
          <div class="form-inline">
            <client-select class="mr-1 mb-2" :model="filterFormModel"  attribute="client" @change="search" :isFilter="true" :place-holder="$t('selectClient')"></client-select>
            <sms-brandname-select :model="filterFormModel" attribute="brandName" client-attribute="client" @input="load" :isFilter="true" class="mr-1 mb-2" />
            <form-select :model="filterFormModel" attribute="type" class="mr-1 mb-2" :options="[
              {text: this.$t('smsType'), value: null},
              {text: this.$t('ads'), value: 'ads'},
              {text: this.$t('care'), value: 'care'},
            ]"></form-select>
            <form-select :model="filterFormModel" attribute="status" class="mr-1 mb-2" :options="[
              {value: null, text: $t('status')},
              {value: 'sending', text: $t('notYetSent')},
              {value: 'success', text: $t('success')},
              {value: 'fail', text: $t('error')}
            ]"></form-select>
            <form-input class="mr-1 mb-2" :model="filterFormModel" attribute="number" v-on:keydown.enter="load"
                          :placeholder="$t('toNumber')"></form-input>
            <time-range-picker :model="filterFormModel" :label="$t('time')" class="mr-1 mb-2" :defaultShortcut="3"></time-range-picker>
            <s-m-s-history-export v-if="['owner','admin', 'tech' , 'operationsManager', 'account'].includes($store.state.user.role)" :filter="filterFormModel" :total-count="itemCount" />
            <button @click="load" class="btn btn-primary mr-1 mb-2">{{ $t('search') }}</button>
            <button @click="reset" class="btn btn-secondary mr-1 mb-2">Reset</button>
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="c-paging clearfix">
          <div class="c-paging__count" v-if="itemCount">
            {{ $t('found', [itemCount]) }}
          </div>
          <div class="c-paging__right">
            <div class="c-paging__numbers">
              <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                            v-model="filterFormModel.page" :total-rows="itemCount" :per-page="filterFormModel.pageSize"
                            @input="load"></b-pagination>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12" v-if="items.length">
        <div class="c-smart-table tile">
          <div class="row c-smart-table__title">
            <div class="col-lg-2">{{ $t('from') }}</div>
            <div class="col-lg-2">{{ $t('to') }}</div>
            <div class="col-lg-4">{{ $t('smsContent') }}</div>
            <div class="col-lg-4">{{ $t('smsStatus') }}</div>
          </div>
          <div class="row" v-for="item in items" :key="item._id">
            <div class="col-lg-2">
              <p><b class="c-smart-table__label">{{ $t('from') }}: </b></p>
              <p><b>{{ $t('client') }}: </b><span>{{ item.client.domain }}</span></p>
              <p><b>Brand name: </b><span>{{ item.brandName.name }}</span></p>
            </div>
            <div class="col-lg-2">
              <p><b class="c-smart-table__label">{{ $t('to') }}: </b></p>
              <p>
                <b>{{ $t('number') }}:&nbsp;</b><span>{{ item.number }}</span>
              </p>
            </div>
            <div class="col-lg-4">
              <p><b class="c-smart-table__label">{{ $t('smsContent') }}: </b></p>
              <p><span v-html="item.content.replace(/\n/g, '<br/>')" ></span></p>
              <p>
                <label class="badge" :class="item.type==='ads' ? 'badge-info' : 'badge-primary'">{{$t(item.type)}}</label>&nbsp;
                <label class="badge badge-warning" v-if="!item.sendTime">{{$t('notYetSent')}}</label>
                <label class="badge badge-danger" v-else-if="item.sendError">{{$t('error')}}</label>
                <label class="badge badge-success" v-else>{{$t('success')}}</label>
                &nbsp;<span v-if="item.sendErrorMsg" class="text-gray-999 small"> {{item.sendErrorMsg}}</span>
              </p>
            </div>
            <div class="col-lg-4">
              <p><b class="c-smart-table__label">{{ $t('smsDetail') }}: </b></p>
              <p>
                <b>{{ $t('createTime') }}:&nbsp;</b><span>{{ item.createTime | moment('HH:mm:ss DD/MM/YYYY') }}</span>
              </p>
              <p v-if="item.sendTime">
                <b>{{ $t('sendTime') }}:&nbsp;</b><span>{{ item.sendTime | moment('HH:mm:ss DD/MM/YYYY') }}</span>
              </p>
              <p v-if="item.chargeTime">
                <b>{{ $t('chargeTime') }}:&nbsp;</b><span>{{ item.chargeTime | moment('HH:mm:ss DD/MM/YYYY') }}</span>
              </p>
              <p v-if="item.chargedFee">
                <b>{{ $t('chargedFee') }}:&nbsp;</b><span>{{ item.chargedFee | numFormat }}</span>
              </p>
              <p v-if="item.numberOfSms">
                <b>{{ $t('numberOfSms') }}:&nbsp;</b><span>{{ item.numberOfSms | numFormat }}</span>
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 text-center text-danger" v-if="!items.length">{{ $t('notFoundSearch') }}</div>
      <div class="col-12" v-if="itemCount">
        <div class="c-paging__count" v-if="itemCount">
          {{ $t('found', [itemCount]) }}
        </div>
        <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                      v-model="filterFormModel.page" :total-rows="itemCount" :per-page="filterFormModel.pageSize"
                      @input="load">
        </b-pagination>
      </div>
    </div>
  </main>
</template>

<script>
import list from '../../mixins/List';
import utils from '../../utils';
import ClientSelect from "../../components/ClientSelect";
import TimeRangePicker from "../../components/TimeRangePicker";
import SmsBrandnameSelect from "@/components/SmsBrandnameSelect";
import SMSHistoryExport from "./SMSHistoryExport";
import _ from 'lodash';

export default {
  components: {TimeRangePicker, ClientSelect, SmsBrandnameSelect, SMSHistoryExport},
  mixins: [list, utils],
  props: ['contactId', 'number'],
  data() {
    return {
      userRole: this.$store.state.user.role,
      service: '/sms',
      autoLoad: true,
      defaultFilterFormModel: {
        client: null,
        brandName: null,
        type: null,
        status: null
      }
    }
  },
  methods: {
    search: _.debounce(function () {
                this.filterFormModel.page = 1;
                this.load();
            }, 200),
  },
  i18n: {
    messages: {
      en: {
        from: 'Sent from',
        to: 'Sent to',
        smsContent: 'SMS content',
        smsStatus: 'SMS status',
        createTime: 'Create time',
        sendTime: 'Send time',
        chargeTime: 'Charge time',
        chargedFee: 'Charged fee',
        notYetSent: 'Not yet sent',
        toNumber: 'Send to number',
        care: 'Care',
        ads: 'Ads',
        smsType: 'Type',
        smsHistory: 'SMS history',
        number: 'Number',
        numberOfSms: 'Number of SMS',
      },
      vi: {
        from: 'Gửi từ',
        to: 'Gửi tới',
        smsContent: 'Nội dung',
        smsStatus: 'Trạng thái',
        createTime: 'Tạo lúc',
        sendTime: 'Gửi lúc',
        chargeTime: 'Tính tiền lúc',
        chargedFee: 'Số tiền',
        notYetSent: 'Chưa gửi',
        toNumber: 'Gửi tới số',
        care: 'CSKH',
        ads: 'Quảng cáo',
        smsType: 'Loại',
        smsHistory: 'Lịch sử SMS',
        number: 'Số điện thoại',
        numberOfSms: 'Tổng tin gửi',
      }
    }
  }
}
</script>